import { useState } from "react";

const Navbar = () => {
  const [display, setDisplay] = useState("hidden");

  const menuItems = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "About",
      link: "#about",
    },
    {
      name: "Services",
      link: "#services",
    },
    {
      name: "Projects",
      link: "#projects",
    },

    {
      name: "Contact",
      link: "#contact",
    },
  ];

  const mobileMenu = (
    <div className={`md:hidden ${display} py-2`}>
      <ul className="flex flex-col absolute left-0 top-0 w-[100%] h-[calc(100vh)] space-y-8 z-10 items-center py-5 bg-white">
        <div className="ml-auto px-8 cursor-pointer hover:bg-slate-300 hover:rounded-full md:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 text-primaryDark"
            onClick={() => setDisplay("hidden")}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        {menuItems.map((item) => (
          <a
            href={item.link}
            className="mx-auto text-primaryDark text-xs font-bold py-2 px-4 hover:cursor-pointer hover:bg-slate-300"
            key={item.name}
            onClick={() => setDisplay("hidden")}
          >
            {item.name}
          </a>
        ))}
      </ul>
    </div>
  );

  return (
    <nav className="flex px-6 items-center py-3 h-15">
      <a
        className="heading text-xl font-bold text-white hover:cursor-pointer"
        href="/"
      >
        <span className="text-primary">X</span>L
      </a>
      <div className="hidden md:inline ml-auto">
        <ul className="flex space-x-2 items-center">
          {menuItems.map((item) => (
            <a
              href={item.link}
              className="text-xs font-bold py-2 px-4 hover:cursor-pointer transition ease-in-out duration-300"
              key={item.name}
            >
              {item.name}
            </a>
          ))}
        </ul>
      </div>

      {/* Mobile Menu  */}
      <div className="ml-auto px-2 py-2 md:hidden">
        {mobileMenu.props.className.includes("md:hidden hidden") ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 text-white"
            onClick={() => setDisplay("")}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 text-white"
            onClick={() => setDisplay("hidden")}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        )}
      </div>

      {mobileMenu}
    </nav>
  );
};

export default Navbar;
